import { render, staticRenderFns } from "./people-roster.vue?vue&type=template&id=42bf2923&"
import script from "./people-roster.vue?vue&type=script&lang=ts&"
export * from "./people-roster.vue?vue&type=script&lang=ts&"
import style0 from "./people-roster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports